angular.module('unica_archive_event.archive_event_controllers', [])

.controller('ArchiveEventBasicController',
	function(
		$rootScope, $scope,
		$uibModal,
		EVENT_TYPES,
		LocationListService, UserListService
	) {

	$scope.forms = {};

	$scope.eventTypes = EVENT_TYPES;

	$scope.locations = [];

	$scope.loadLocations = function() {
		LocationListService
			.fullList()
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.locations = data;
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	/**
	 * FUNCTIONS FOR PREPARING THE STAGES DATES AND CHECKING STAGES VALIDATION
	 */
	$scope.parseDatesFromDateToTimestamp = function(stages) {
		if ( stages.length > 0 ) {
			var i = 0;
			for ( ; i < stages.length; i++ ) {
				stages[i].from_date = moment( stages[i].from_date ).format('YYYY-MM-DD');
				stages[i].from_time = moment( stages[i].from_time ).format('HH:mm:ss');
				stages[i].to_date   = moment( stages[i].to_date ).format('YYYY-MM-DD');
				stages[i].to_time   = moment( stages[i].to_time ).format('HH:mm:ss');


			}
		}
		return stages;
	};

})